module.exports = __webpack_public_path__ + "assets/retina_Sqrt3Detailed.a019d0d852b27135475f5c9a7e525805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Sqrt3Detailed.png
// module id = 716
// module chunks = 0